import { placeholderImage } from '@grandvisionhq/utils';

const DEFAULT_SUFFIX = '?q=70&w=1200&h=630&fit=fill&fm=jpeg';
const THUMBNAIL_SUFFIX = '?w=64&fm=jpeg&auto=format';
const getProductImageUrl = (media, suffix)=>{
    var ref;
    if (!(media === null || media === void 0 ? void 0 : media.images) || !(media === null || media === void 0 ? void 0 : media.images.length)) {
        return `${placeholderImage.url}${suffix !== null && suffix !== void 0 ? suffix : DEFAULT_SUFFIX}`;
    }
    // The label 'Front' comes from Bynder Images
    return `${(ref = media === null || media === void 0 ? void 0 : media.images.filter((image)=>image.label === 'Front'
    )[0]) === null || ref === void 0 ? void 0 : ref.url}${suffix !== null && suffix !== void 0 ? suffix : DEFAULT_SUFFIX}`;
};
const getVariantItemImageUrl = (media)=>getProductImageUrl(media, THUMBNAIL_SUFFIX)
;

export { getProductImageUrl, getVariantItemImageUrl };
//# sourceMappingURL=get-product-image-url.js.map
